import React from "react";

interface INoteProps {
  note: string;
}

const Note: React.FC<INoteProps> = ({ note }) => {
  return (
    <div className="text-brightOrange text-xs p-3  bg-[#FFF6EC]">
      <span className="font-bold">Note : </span>
      {note}
    </div>
  );
};

export default Note;
